import axiosStatic from "axios";
import {ClientAuthError} from 'msal';
import { config } from '../config';
import { firebaseService } from "./firebaseService";

export const axios = axiosStatic.create({
    baseURL: config.apiUrl
});

// Second axios instance for elgin azure api with different base URL
export const axiosAzureAPI = axiosStatic.create({
    baseURL: config.azureApiUrl,
});

axios.interceptors.request.use(async requestConfig => {
    if (requestConfig.url?.startsWith('/')) {
        try {
            const accessToken = await firebaseService.auth().currentUser?.getIdToken();
            if (accessToken) {
                requestConfig.headers["Authorization"] = `Bearer ${accessToken}`;
            }
        } catch (e) {
            // if the error is ClientAuthError, we do NOT want to throw
            // instead, perform the request without an Authorization header
            if ((e as ClientAuthError).name !== "ClientAuthError") {
                throw e;
            }
        }
    }
    return requestConfig;
});

// Apply the same interceptors to the localhost axios instance
axiosAzureAPI.interceptors.request.use(async requestConfig => {
    if (requestConfig.url?.startsWith('/')) {
        try {
            const accessToken = await firebaseService.auth().currentUser?.getIdToken();
            if (accessToken) {
                requestConfig.headers["Authorization"] = `Bearer ${accessToken}`;
            }
        } catch (e) {
            // if the error is ClientAuthError, we do NOT want to throw
            // instead, perform the request without an Authorization header
            if ((e as ClientAuthError).name !== "ClientAuthError") {
                throw e;
            }
        }
    }
    return requestConfig;
});

axios.interceptors.response.use(async response => {
    return response;
});

axiosAzureAPI.interceptors.response.use(async response => {
    return response;
});

export class AxiosService {
    private static staticAxios = axios;

    protected get axios() {
        return AxiosService.staticAxios;
    }

    protected constructor() {}
}